export const ipSearchBaseURL = "https://www.sandisk.com"
export const baseStageURL = "https://www-stage.sandisk.com";

export const sdGlobalSearchBaseURL = ipSearchBaseURL+"/sandisk/tools/api/globalsearchquery";
export const sdSupportSearchBaseURL = ipSearchBaseURL+"/tools/api/globalsearchgroups";

export const newSdSupportSearchBaseURL = baseStageURL+"/tools/api/globalsearchquery";
export const newSdGroupApiBaseURL = baseStageURL+"/tools/api/globalsearchgroups";

export const suggestionAPI= baseStageURL+"/tools/api/searchsuggester"
export const corporateInfoURL= baseStageURL+'/content/experience-fragments/sndsk/newsroom/latest-corporate-information/master'
export const getHeadersURL = baseStageURL+'/content/experience-fragments/sndsk/header/shared-header/osc/header/master'
export const getFooterURL= baseStageURL+'/content/experience-fragments/sndsk/footer/shared-footer/hybris/footer/master'



// Locales where product price must NOT be shown anywhere on the search page
export const PRICE_HIDDEN_LOCALES = ["es-es"];
export const isPriceHiddenForLocale = (locale) =>
  PRICE_HIDDEN_LOCALES.includes(String(locale || "").toLowerCase());

//Western Digital Search URLs starts
const LOCALE_RE = /^\/([a-z]{2}-[a-z]{2})(?=\/|$)/i;

function detectLocale() {
  if (typeof window === "undefined") return "en-us";
  const m = window.location.pathname.match(LOCALE_RE);
  return (m ? m[1] : "en-us").toLowerCase();
}

function buildAemXF(host, xfPath) {
  const locale = detectLocale();
  const p = xfPath.replace(/\/{2,}/g, "/");
  const out = locale === "en-us"
    ? p.replace(/\/([a-z]{2}-[a-z]{2})\/?$/i, "/master")
    : p.replace(/\/master\/?$/i, `/${locale}`);
  return `${host}${out}`;
}
// for header and footer
export const corporateURL=process.env.REACT_APP_CORPORATE_URL
export const stageCloudUrl=process.env.REACT_APP_GLOBAL_SEARCH_URL

export const getWDHeadersURL = buildAemXF(corporateURL, '/content/experience-fragments/store/nav/header/header-xf/master');
export const getWDFooterURL = buildAemXF(corporateURL, '/content/experience-fragments/store/nav/footer/footer-xf/master');

// global search and suggestion querries. 
export const getGlobalSearchGroupURL = stageCloudUrl+"/tools/api/globalsearchgroups";
export const getSearchSuggestURL = stageCloudUrl+"/tools/api/searchsuggester";
export const getGlobalSearchQueryURL = stageCloudUrl+"/tools/api/globalsearchquery";
export const XF_BASE = corporateURL+"/content/experience-fragments/store/search/product-support-suggestions";

// for price of the product on search page
export const productPrice = "https://www.westerndigital.com/store/cart/guest/products/priceAndInventory";
export const productPriceProdUrl = "https://www.westerndigital.com/";


// before url used
export const getSearchResultsURL = corporateURL+"/tools/shopsearchquery"
export const getSearchFaceURL = corporateURL+"/tools/shopsearchfacets"
export const getSearchSuggestionURL = corporateURL+ "/tools/shopsearchsuggest"
export const getRealSearchSuggestionURL = corporateURL+ "/tools/shopsuggest"
export const getNewsRoomfacet='https://www.sandisk.com/tools/api/globalsearchquery'